import React from 'react';
import PropTypes from 'prop-types';
import { formatClass } from '../../helpers/';

const Button = props => {
  const classes = formatClass(`btn ${props.primary ? 'btn-primary-red ' : ''}
    ${props.secondary ? 'btn-secondary-blue ' : ''}
    ${!props.primary && !props.secondary ? 'btn-default ' : ''}
    ${props.large ? 'btn-large ' : ''}
    ${props.customClass}`);

  return <button type="button" className={(classes)} onClick={() => props.onClick()} disabled={props.disabled}>{props.label}</button>;
};

Button.propTypes = {
  label: PropTypes.string,
  primary: PropTypes.bool,
  secondary: PropTypes.bool,
  large: PropTypes.bool,
  onClick: PropTypes.func,
  customClass: PropTypes.string,
  disabled: PropTypes.bool,
};

Button.defaultProps = {
  label: 'Click me',
  primary: false,
  secondary: false,
  large: false,
  onClick: () => { return undefined; },
  customClass: '',
  disabled: false,
};

export default Button;



// WEBPACK FOOTER //
// ./src/main/ui/react/shared/components/Button/Button.js